import { DataModelBase } from "./datamodel-base-model";

export class ApplicationIdInData extends DataModelBase {
  public ApplicationID: string = "";
  public TransactionEventSeqNumb: number = 0;
}
